<template>
  <div>
    <div class="panel">
      <div class="filter">
        <el-form
          label-position="right"
          class="search-form"
          label-width="80px"
          inline
          @submit.native.prevent
          size="small"
        >
          <el-form-item label="成品分类">
            <ProductTemplateSelect
              v-model="filter.product_template_id"
              :category="category - 1"
              :clearable="true"
            ></ProductTemplateSelect>
          </el-form-item>
          <el-form-item label="关键字">
            <el-input
              size="small"
              v-model="filter.product_code"
              autocomplete="off"
              placeholder="编号|区块|井队号|井号|备注"
              @keyup.enter.native="query()"
            ></el-input>
          </el-form-item>
          <el-form-item label="上报基地">
            <BaseSelect v-model="filter.base_id" :clearable="true"></BaseSelect>
          </el-form-item>
          <el-form-item label="使用日期" prop="date">
            <el-date-picker
              v-model="filter.date"
              type="daterange"
              size="small"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <div style="margin-left: 80px">
          <el-button type="primary" size="small" @click="query()"
            >筛选</el-button
          >
          <el-button size="small" @click="reset()">重置</el-button>
        </div>
      </div>
    </div>
    <div class="panel mt-20">
      <el-button
        type="primary"
        size="small"
        icon="el-icon-plus"
        @click="handleAdd"
        >新增使用记录</el-button
      >
      <file-button
        :obj="category == 2 ? 'product_record' : 'instrument_record'"
        :filter="filter"
        @importCallback="reset"
      ></file-button>
      <el-table :data="list" size="small" class="mt-10" v-loading="loading">
        <el-table-column
          align="left"
          label="上报人 / 上报基地"
          prop="user_name"
        >
          <template slot-scope="scope">
            {{ scope.row.user_name }} / {{ scope.row.base.name }}
          </template>
        </el-table-column>
        <el-table-column label="成品编号(分类)" prop="product_code">
          <template slot-scope="scope"
            >{{ scope.row.product_code }}
            {{
              scope.row.template.name ? `(${scope.row.template.name})` : ''
            }}</template
          >
        </el-table-column>
        <el-table-column
          align="center"
          label="使用日期"
          prop="created_at_human"
        >
          <template slot-scope="scope">
            {{ $time(scope.row.used_date).format('YYYY-MM-DD') }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="工作时长" prop="used_hour">
        </el-table-column>
        <el-table-column align="center" label="使用区块">
          <template slot-scope="scope">
            {{ scope.row.used_extra[0].value }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="井队号">
          <template slot-scope="scope">
            {{ scope.row.used_extra[1].value }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="井号">
          <template slot-scope="scope">
            {{ scope.row.used_extra[2].value }}
          </template>
        </el-table-column>
        <el-table-column align="left" label="备注/图片/视频" min-width="90">
          <template slot-scope="scope">
            <div v-html="scope.row.remark"></div>
            <div class="medio-container">
              <el-image
                v-for="url in scope.row.imgs"
                :key="url"
                style="width: 30px; height: 30px; margin-right: 5px"
                :src="url"
                :preview-src-list="scope.row.imgs"
              >
              </el-image>
              <VideoPlayer :srcs="scope.row.videos"></VideoPlayer>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <template v-if="scope.row.user_id == $store.state.userInfo.id">
              <el-popconfirm
                title="确认删除该使用记录吗？"
                @confirm="hanldeDelte(scope.row, scope.$index)"
              >
                <el-button
                  slot="reference"
                  type="text"
                  size="small"
                  class="text-danger"
                  >删除</el-button
                >
              </el-popconfirm>
              <el-button
                type="text"
                size="small"
                class="ml-5"
                @click="handleEdit(scope.$index, scope.row)"
                >编辑</el-button
              >
            </template>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>

      <Former
        :model="model"
        :show.sync="dialogVisible"
        @created="createdCallback"
        @updated="updatedCallback"
      ></Former>
    </div>
  </div>
</template>

<script>
import { productRecordList, productRecordDelete } from '@/service/getData'
import Former from './former'

export default {
  components: {
    Former,
  },
  watch: {
    'filter.page': function () {
      this.getData()
    },
  },
  props: {
    category: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      model: {},
      filter: {
        page: 1,
        size: 10,
        product_template_id: '',
        product_code: '',
        date: '',
        base_id: '',
        add_type: this.category,
      },
      total: 0,
      editIndex: 0,
      list: [],
      loading: false,
      dialogVisible: false,
    }
  },
  created() {
    if (this.$route.query.filter) {
      this.filter = this.filterDecode(this.$route.query.filter)
    }
    this.getData()
  },
  methods: {
    query() {
      this.filter.page = 1
      this.getData()
    },
    async getData() {
      this.$router.replace({
        query: this.filterEncode(this.filter),
      })

      let params = this.clone(this.filter)
      params.page -= 1
      params.add_type = this.category
      if (params.date && params.date.length == 2) {
        params.start_date = params.date[0]
        params.end_date = params.date[1]
      }

      this.loading = true
      let res = await productRecordList(params)
      if (res.code == 0) {
        this.list = res.data.list
        this.total = res.data.count
        this.loading = false
      }
    },
    createdCallback(data) {
      this.list.unshift(data)
    },
    updatedCallback(data) {
      this.$set(this.list, this.editIndex, data)
    },
    handleAdd() {
      let used_extra = [
        { key: 'block', value: '', label: '使用区块' },
        { key: 'well_team_number', value: '', label: '井队号' },
        { key: 'well_number', value: '', label: '井号' },
      ]
      this.model = {
        product_template_id: '',
        product_id: '',
        product_code: '',
        used_date: '',
        used_hour: 0,
        used_extra: used_extra,
        imgs: [],
        videos: [],
        remark: '',
        add_type: this.category,
        drill_well_id: '',
      }

      this.dialogVisible = true
    },
    handleEdit(index, item) {
      this.model = this.clone(item)
      if (!this.model.product_template_id) {
        this.model.product_template_id = ''
      }
      this.editIndex = index
      this.dialogVisible = true
    },
    async hanldeDelte(item, index) {
      let res = await productRecordDelete(item.id)
      if (res.code == 0) {
        this.list.splice(index, 1)
      }
    },
    reset() {
      this.filter.page = 1
      this.filter.product_template_id = ''
      this.filter.product_code = ''
      this.filter.date = ''
      this.filter.base_id = ''
      this.getData()
    },
  },
}
</script>